// valeaf — kleine Interaktionen: Zubehör/Bundle in den Warenkorb, FAQ-Suche, „Mehr lesen“, Countdown.
import { CartAddEvent } from '@theme/events';

async function addItems(items, source) {
  const res = await fetch(`${window.Theme?.routes?.cart_add_url || '/cart/add'}.js`.replace('.js.js', '.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items }),
  });
  const body = await res.json();
  if (!res.ok || body.status) throw new Error(body.description || body.message || 'Fehler');
  const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
  document.dispatchEvent(
    new CartAddEvent(cart, source, { source: 'valeaf', itemCount: items.reduce((n, i) => n + i.quantity, 0) })
  );
  updateShipping(cart);
  const drawer = document.querySelector('cart-drawer-component');
  if (drawer && typeof drawer.open === 'function') drawer.open();
  return cart;
}

// „Passt dazu“: Gratis-Versand-Hinweis nach dem Hinzufügen neu rechnen (Cent)
function updateShipping(cart) {
  document.querySelectorAll('[data-vl-upsell]').forEach((box) => {
    const threshold = Number(box.dataset.threshold);
    const text = box.querySelector('[data-vl-ship-text]');
    const bar = box.querySelector('[data-vl-ship-bar]');
    if (!threshold || !text) return;
    const inCart = cart.items.some((i) => String(i.product_id) === box.dataset.productId);
    const basis = cart.total_price + (inCart ? 0 : Number(box.dataset.productPrice));
    const missing = threshold - basis;
    const euro = (c) => (c / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    text.innerHTML = missing > 0
      ? `Noch <strong>${euro(missing)}</strong> bis zum <strong>Gratis-Versand</strong>.`
      : '✓ <strong>Gratis-Versand</strong> ist drin.';
    if (bar) bar.style.width = `${Math.min(100, Math.round((basis * 100) / threshold))}%`;
  });
}

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-vl-add]');
  if (!button) return;
  event.preventDefault();
  const ids = button.dataset.vlAdd.split(',').filter(Boolean);
  const label = button.innerHTML;
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  try {
    await addItems(ids.map((id) => ({ id: Number(id), quantity: 1 })), button.id || 'valeaf-add');
    button.innerHTML = button.dataset.vlAdded || '✓ Im Korb';
  } catch (error) {
    button.innerHTML = 'Nicht verfügbar';
    console.warn('[valeaf] add to cart', error);
  } finally {
    button.removeAttribute('aria-busy');
    setTimeout(() => {
      button.disabled = false;
      button.innerHTML = label;
    }, 2500);
  }
});

// Mehr lesen (Kollektions-Intro, SEO-Text, Sorten-Tabelle)
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-vl-toggle]');
  if (!toggle) return;
  const target = document.getElementById(toggle.dataset.vlToggle);
  if (!target) return;
  if (target.hasAttribute('data-collapsed')) {
    const collapsed = target.dataset.collapsed === 'true';
    target.dataset.collapsed = String(!collapsed);
  } else if (target.hasAttribute('data-clamp')) {
    target.dataset.clamp = String(target.dataset.clamp !== 'true');
  } else {
    target.querySelectorAll('[hidden]').forEach((el) => el.removeAttribute('hidden'));
    toggle.remove();
    return;
  }
  const expanded = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!expanded));
  toggle.textContent = expanded ? toggle.dataset.more || 'Mehr lesen' : toggle.dataset.less || 'Weniger';
});

// FAQ: Suche + Kategorie-Chips
document.querySelectorAll('[data-vl-faq]').forEach((root) => {
  const input = root.querySelector('[data-vl-faq-search]');
  const chips = root.querySelectorAll('[data-vl-faq-cat]');
  const items = root.querySelectorAll('.vl-faq__item');
  let cat = '';
  const apply = () => {
    const q = (input?.value || '').trim().toLowerCase();
    items.forEach((item) => {
      const okText = !q || item.textContent.toLowerCase().includes(q);
      const okCat = !cat || item.dataset.cat === cat;
      item.hidden = !(okText && okCat);
      if (q && okText) item.open = true;
    });
  };
  input?.addEventListener('input', apply);
  chips.forEach((chip) =>
    chip.addEventListener('click', () => {
      cat = chip.getAttribute('aria-pressed') === 'true' ? '' : chip.dataset.vlFaqCat;
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip && cat !== '')));
      apply();
    })
  );
});

// Countdown bis Bestellschluss
document.querySelectorAll('[data-vl-countdown]').forEach((el) => {
  const end = new Date(el.dataset.vlCountdown).getTime();
  if (Number.isNaN(end)) return;
  const tick = () => {
    const left = end - Date.now();
    if (left <= 0) {
      el.innerHTML = el.dataset.expired || '';
      return;
    }
    const d = Math.floor(left / 864e5);
    const h = Math.floor((left % 864e5) / 36e5);
    const m = Math.floor((left % 36e5) / 6e4);
    el.innerHTML = `<b>${d} T</b><b>${String(h).padStart(2, '0')} Std</b><b>${String(m).padStart(2, '0')} Min</b>`;
    setTimeout(tick, 30000);
  };
  tick();
});

// footer columns: accordions on mobile, always open on desktop
(function () {
  var mq = window.matchMedia('(min-width: 990px)');
  function sync() { document.querySelectorAll('.vl-footer__col').forEach(function (d) { if (mq.matches) d.setAttribute('open', ''); }); }
  sync(); mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync);
})();
